var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/SettingFilter.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SettingFilter = ({
  color = '#353B60',
  secondColor = '#fff',
  ...other
}) => /*#__PURE__*/_jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#clip0_69_104108)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 7C3 7.55 3.45 8 4 8H20C20.55 8 21 7.55 21 7C21 6.45 20.55 6 20 6H4C3.45 6 3 6.45 3 7ZM11 18H13C13.55 18 14 17.55 14 17C14 16.45 13.55 16 13 16H11C10.45 16 10 16.45 10 17C10 17.55 10.45 18 11 18ZM17 13H7C6.45 13 6 12.55 6 12C6 11.45 6.45 11 7 11H17C17.55 11 18 11.45 18 12C18 12.55 17.55 13 17 13Z",
      fill: color
    }), /*#__PURE__*/_jsx("g", {
      clipPath: "url(#clip1_69_104108)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M14.4227 12.435C13.92 12.218 13.3344 12.4152 13.0629 12.8909L11.9728 14.7797L11.9728 14.7797L11.9712 14.7826C11.7025 15.2555 11.8214 15.85 12.2513 16.1832L12.2512 16.1832L12.2555 16.1864L13.1274 16.8474C13.1258 16.8982 13.125 16.9494 13.125 17.0013C13.125 17.0552 13.1259 17.1082 13.1276 17.1609L12.2575 17.8205C12.2571 17.8208 12.2567 17.8211 12.2563 17.8214C11.8163 18.1523 11.7052 18.7577 11.9712 19.2258L11.9711 19.2258L11.9732 19.2293L13.0631 21.112C13.3346 21.5875 13.9201 21.7846 14.4227 21.5676L15.4276 21.1423C15.5163 21.1978 15.607 21.2507 15.6997 21.3008L15.8353 22.3809C15.8353 22.3814 15.8354 22.3819 15.8355 22.3824C15.9013 22.9246 16.3649 23.3346 16.9092 23.3346H19.085C19.6294 23.3346 20.093 22.9245 20.1588 22.3824C20.1589 22.3819 20.1589 22.3814 20.159 22.3809L20.2946 21.3008C20.3873 21.2507 20.478 21.1978 20.5667 21.1423L21.5716 21.5676C22.0742 21.7846 22.6596 21.5875 22.9311 21.1121L24.0211 19.2293L24.0211 19.2293L24.0231 19.2258C24.2918 18.7529 24.1729 18.1584 23.743 17.8253L23.743 17.8252L23.7388 17.822L22.8721 17.165C22.8742 17.1099 22.875 17.0555 22.875 17.0013C22.875 16.9474 22.8742 16.8944 22.8725 16.8417L23.7425 16.1821C23.7429 16.1818 23.7433 16.1815 23.7437 16.1813C24.1838 15.8503 24.2949 15.2449 24.0289 14.7768L24.029 14.7768L24.0269 14.7733L22.9369 12.8906C22.6654 12.4151 22.08 12.218 21.5774 12.435L20.5725 12.8603C20.4838 12.8049 20.3931 12.7519 20.3004 12.7018L20.1648 11.6217C20.1648 11.6212 20.1647 11.6207 20.1646 11.6202C20.0988 11.0781 19.6352 10.668 19.0909 10.668H16.915C16.368 10.668 15.9017 11.075 15.8355 11.6202L15.6997 12.7018C15.607 12.7519 15.5163 12.8049 15.4276 12.8603L14.4227 12.435ZM18.0234 18.543C17.1737 18.543 16.4817 17.851 16.4817 17.0013C16.4817 16.1516 17.1737 15.4596 18.0234 15.4596C18.8731 15.4596 19.565 16.1516 19.565 17.0013C19.565 17.851 18.8731 18.543 18.0234 18.543Z",
        fill: color,
        stroke: secondColor
      })
    })]
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsx("clipPath", {
      id: "clip0_69_104108",
      children: /*#__PURE__*/_jsx("rect", {
        width: "24",
        height: "24",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "clip1_69_104108",
      children: /*#__PURE__*/_jsx("rect", {
        width: "14",
        height: "14",
        fill: "white",
        transform: "translate(11 10)"
      })
    })]
  })]
});